export const spacing = {
  xs: 8,
  sm: 16,
  md: 32,
  lg: 64,
  xl: 80,
};
